// removed by extract-text-webpack-plugin
module.exports = {"box":"U8dlwRV3CX2Vg1tnM0IGK","boxHead":"_10v_3k883h8BqjR_0g4dPK","boxContent":"_1plTR5oQMm7T6W9diCv5ev","userInfoBox":"_2SMaEtP-wcAk5Awc15R0_2","editIcon":"_2RzENMhTsfsRcBmG03tMjJ","addressBox":"_2n1R9Vm-4CP2eqHN-FyPX5","provinceBox":"_1jegPu_iovI9NX5JXi5ZbH","province":"_3kimpeUHI-7_ZWMXwhRI3-","district":"_32R2t4IlqWxEULRM-eNGeO","selectAddress":"_16SHtuBRCTsCNQ3i282_d3","marginTop":"O28LqyDJ7j_lDVWkxk0Hr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ContactInfo.scss
// module id = 1104
// module chunks = 0